'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { trackSocialClick } from '../../lib/analytics';

export default function Footer() {
    const pathname = usePathname();
    const isHome = pathname === '/';

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <p className="footer-text">
                        © {new Date().getFullYear()} Victor Tomaili. Tüm hakları saklıdır.
                    </p>
                    <div className="footer-links">
                        {!isHome && (
                            <Link href="/">Portfolyo</Link>
                        )}
                        <a
                            href="https://github.com/victortomaili"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackSocialClick('github')}
                        >
                            GitHub
                        </a>
                        <a
                            href="https://linkedin.com/in/vtomaili"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackSocialClick('linkedin')}
                        >
                            LinkedIn
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
